<div class="app-page">
  <div class="app-page-content">
    <section class="app-card">
      <header class="mb-6">
        <div class="flex items-center gap-3 mb-2">
          <button
            pButton
            type="button"
            icon="pi pi-arrow-left"
            class="p-button-text p-button-sm"
            (click)="onCancel()">
          </button>
          <h1 class="section-title">{{ pageTitle }}</h1>
        </div>
        <p class="section-subtitle">
          {{ isEditMode() ? 'Modifica los datos del formato digital' : 'Completa los datos del nuevo formato digital' }}
        </p>
      </header>

      <form [formGroup]="formatoForm" (ngSubmit)="onSubmit()">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="flex flex-col gap-2">
            <label for="codigo" class="font-medium text-sm">
              Código <span class="text-red-500">*</span>
            </label>
            <input
              id="codigo"
              type="text"
              pInputText
              formControlName="codigo"
              placeholder="Ingrese el código del formato"
              class="w-full"
              [class.ng-invalid]="formatoForm.get('codigo')?.invalid && formatoForm.get('codigo')?.touched"
            />
            <small
              *ngIf="formatoForm.get('codigo')?.invalid && formatoForm.get('codigo')?.touched"
              class="text-red-500">
              El código es requerido
            </small>
          </div>

          <div class="flex flex-col gap-2">
            <label for="nombre" class="font-medium text-sm">
              Nombre <span class="text-red-500">*</span>
            </label>
            <input
              id="nombre"
              type="text"
              pInputText
              formControlName="nombre"
              placeholder="Ingrese el nombre del formato"
              class="w-full"
              [class.ng-invalid]="formatoForm.get('nombre')?.invalid && formatoForm.get('nombre')?.touched"
            />
            <small
              *ngIf="formatoForm.get('nombre')?.invalid && formatoForm.get('nombre')?.touched"
              class="text-red-500">
              El nombre es requerido
            </small>
          </div>

          <div class="flex flex-col gap-2">
            <label for="tipo" class="font-medium text-sm">
              Tipo <span class="text-red-500">*</span>
            </label>
            <p-select
              id="tipo"
              formControlName="tipo"
              [options]="tipoOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar tipo"
              [appendTo]="'body'"
              class="w-full">
            </p-select>
          </div>

          <div class="flex flex-col gap-2">
            <label for="ancho" class="font-medium text-sm">
              Ancho (px)
            </label>
            <p-inputNumber
              id="ancho"
              formControlName="ancho"
              [min]="1"
              [maxFractionDigits]="0"
              placeholder="Ancho"
              class="w-full">
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="alto" class="font-medium text-sm">
              Alto (px)
            </label>
            <p-inputNumber
              id="alto"
              formControlName="alto"
              [min]="1"
              [maxFractionDigits]="0"
              placeholder="Alto"
              class="w-full">
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="active" class="font-medium text-sm">
              Estado
            </label>
            <div class="flex items-center gap-3">
              <p-toggleSwitch
                id="active"
                formControlName="active">
              </p-toggleSwitch>
              <span class="text-sm text-muted">
                {{ formatoForm.get('active')?.value ? 'Activo' : 'Inactive' }}
              </span>
            </div>
          </div>
        </div>

        <div class="flex items-center gap-3 mt-8 pt-6 border-t border-border">
          <button
            pButton
            type="submit"
            [label]="isEditMode() ? 'Actualizar' : 'Crear'"
            icon="pi pi-check"
            class="p-button-sm"
            [disabled]="loading() || formatoForm.invalid">
          </button>
          <button
            pButton
            type="button"
            label="Cancelar"
            icon="pi pi-times"
            class="p-button-outlined p-button-sm"
            (click)="onCancel()"
            [disabled]="loading()">
          </button>
        </div>
      </form>
    </section>
  </div>
</div>
